
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CourseCreateDto, CourseDto } from '../../Manipulate/CoursesObjects/CourseDto';

@Injectable({
  providedIn: 'root'
})
export class CourseService {
  private apiUrl = environment.apiUrl + '/course';

  constructor(private http: HttpClient) { }


  public ListCourses() : Observable<any>{
    return this.http.get(`${this.apiUrl}`);
  }
  public ListPublicCourses() : Observable<any>{
    return this.http.get(`${this.apiUrl}/public`);
  }
  public GetCourseById(id:string) : Observable<any>{
    return this.http.get(`${this.apiUrl}/byId/${id}`);
  }
  public AddCourse(dto:CourseCreateDto) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}`,dto);
  }
  public Thumbnail(courseId:string, thumbnailFile:FormData) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/thumbnail/${courseId}`,thumbnailFile);
  }
  public EditCourse(dto: CourseDto): Observable<any> {
    return this.http.put(`${this.apiUrl}/${dto.id}`, dto);
  }
  public Delete(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }


}
